export const sanitizeComment = (comment: string) => comment.replace(/’/g, "'");
